module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@2x-9bf8e2b91f6f6263c99ec12ed869532a.png";